import { Box, Heading, Container, FormControl, FormLabel, Input, SimpleGrid, Textarea, Checkbox, ButtonGroup, Button, Select, FormErrorMessage, Text, Image, Divider } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import Layout from "scenes/layouts";
import LoadingScreen from "components/loading-screen";
import { Field, Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import AuthorService from "services/authors/author-service";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ProgramService from "../../../services/programs/program-service";
import { ImageResize } from 'quill-image-resize-module-ts';
import BlotFormatter from 'quill-blot-formatter';
import UMAIService from "services/umai/umai-service";

ReactQuill.Quill.register('modules/imageResize', ImageResize);
ReactQuill.Quill.register('modules/blotFormatter', BlotFormatter);

const formInitialValue = {
    authorId: '',
    code: '',
    name: '',
    fullName: '',
    description: '',
    isFeaturedInHomePage: false,
    overview: '',
    priceOriginal: '',
    price: '',
    posterUrl: '',
    commissionFee: 0,
    umaiPrefixTag: '',
    umaiPipelineId: ''
};

const ProgramEditScene = (): ReactElement => {
    const navigate = useNavigate();
    const [isLoading, setLoad] = useState<boolean>(false);
    const [isSaving, setSaving] = useState<boolean>(false);
    const [formValue, setFormValue] = useState<any>(formInitialValue);
    const [authors, setAuthors] = useState<any[]>([]);
    const [overview, setOverview] = useState('');
    const { programId }: any = useParams();
    const [salesPipelines, setSalesPipelines] = useState<any[]>([]);

    useEffect(() => {
        setLoad(true);

        ProgramService.GetProgramAdmin(programId).then((response: any) => {
            const program = response.result;
            program.authorId = program.author.id;
            setFormValue(program);
            setOverview(response.result.overview);

            AuthorService.GetAll().then((res: any) => {
                setAuthors(res.result);

                UMAIService.GetPipelines().then((res: any) => {
                    setSalesPipelines(res.result);
                }).finally(() => {
                    setLoad(false);
                });
            });

        })
    }, []);

    const handleFormSubmit = (values: any) => {
        setSaving(true);
        ProgramService.Edit(programId, values.code, values.name, values.fullName, values.description, values.isFeaturedInHomePage, overview, values.priceOriginal, values.price, values.commissionFee, values.authorId, values.umaiPrefixTag, values.umaiPipelineId).then((res: any) => {
            navigate(`/programs/${programId}`);
        }).finally(() => {
            setSaving(false);
        })
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'align': [] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            ['link', 'image', 'video'],
            ['clean']
        ],
        clipboard: {
            // toggle to add extra line breaks when pasting HTML:
            matchVisual: false
        },
        imageResize: {
            parchment: ReactQuill.Quill.import('parchment'),
            modules: ['Resize', 'DisplaySize']
        },
        //blotFormatter: { }
    };

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image', 'video', 'align', 'color', 'background'
    ]

    if (isLoading)
        return <LoadingScreen />;

    return (
        <Layout>
            <Container maxWidth={"8xl"} mt={2} mb={5}>
                <Box>
                    <Heading fontSize={'3xl'} fontWeight={"extrabold"}>Edit Program - {formValue.name}</Heading>
                </Box>
                <Box mt={6}>
                    <Formik initialValues={formValue} onSubmit={handleFormSubmit}>
                        {
                            ({ handleSubmit, errors, touched, setFieldValue, values }) => (
                                <form onSubmit={handleSubmit} noValidate={true}>

                                    <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>

                                        <Box>
                                            <Box px={0} py={4}>
                                                <SimpleGrid columns={{ base: 1, md: 2 }} gap={6}>
                                                    <FormControl isRequired isInvalid={!!(errors.code && touched.code)}>
                                                        <FormLabel htmlFor='code'>Kode Program</FormLabel>
                                                        <Field
                                                            as={Input}
                                                            id='code'
                                                            name={'code'}
                                                            placeholder='Kode Program'
                                                            validate={(value: any) => {
                                                                let error;
                                                                if (value.length <= 0) {
                                                                    error = "Kode Program wajib diisi."
                                                                }
                                                                return error;
                                                            }} />
                                                        <FormErrorMessage>{errors.code}</FormErrorMessage>
                                                    </FormControl>
                                                    <FormControl>
                                                    </FormControl>
                                                </SimpleGrid>
                                            </Box>

                                            <Box px={0} py={4}>
                                                <SimpleGrid columns={{ base: 1, md: 2 }} gap={6}>
                                                    <FormControl isRequired isInvalid={!!(errors.name && touched.name)}>
                                                        <FormLabel htmlFor='name'>Nama Program</FormLabel>
                                                        <Field
                                                            as={Input}
                                                            id='name'
                                                            name={'name'}
                                                            placeholder='Nama Program'
                                                            validate={(value: any) => {
                                                                let error;
                                                                if (value.length <= 0) {
                                                                    error = "Nama Program wajib diisi."
                                                                }
                                                                return error;
                                                            }} />
                                                        <FormErrorMessage>{errors.name}</FormErrorMessage>
                                                    </FormControl>
                                                    <FormControl isRequired isInvalid={!!(errors.fullName && touched.fullName)}>
                                                        <FormLabel htmlFor='fullName'>Nama Lengkap Program</FormLabel>
                                                        <Field
                                                            as={Input}
                                                            id='fullName'
                                                            name={'fullName'}
                                                            placeholder='Nama Lengkap Program'
                                                            validate={(value: any) => {
                                                                let error;
                                                                if (value.length <= 0) {
                                                                    error = "Nama Lengkap Program wajib diisi."
                                                                }
                                                                return error;
                                                            }} />
                                                        <FormErrorMessage>{errors.fullName}</FormErrorMessage>
                                                    </FormControl>
                                                </SimpleGrid>
                                            </Box>

                                            <Box px={0} py={4}>
                                                <FormControl isRequired isInvalid={!!(errors.description && touched.description)}>
                                                    <FormLabel htmlFor='description'>Deskripsi Singkat</FormLabel>
                                                    <Field
                                                        as={Textarea}
                                                        id='description'
                                                        name={'description'}
                                                        placeholder='Penjelasan Singkat tentang program ini'
                                                        rows={5}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Deskripsi Singkat wajib diisi."
                                                            }
                                                            if (value.length > 320) {
                                                                error = "Deskripsi Singkat tidak boleh lebih dari 320 huruf."
                                                            }
                                                            return error;
                                                        }} />
                                                    <FormErrorMessage>{errors.description}</FormErrorMessage>
                                                </FormControl>
                                            </Box>


                                            <Box px={0} py={4}>
                                                <FormControl isRequired isInvalid={!!(errors.authorId && touched.authorId)}>
                                                    <FormLabel htmlFor='author'>Author</FormLabel>
                                                    <Field
                                                        as={Select}
                                                        id='author'
                                                        name={'authorId'}
                                                        placeholder='Pilih Author'
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (!value)
                                                                error = "Silahkan pilih Author Program ini";
                                                            return error;
                                                        }}
                                                    >
                                                        {
                                                            authors.map((author: any) => {
                                                                return <option value={author.id}>{`${author.name} - ${author.shortBioData}`}</option>
                                                            })
                                                        }
                                                    </Field>
                                                    <FormErrorMessage>{errors.authorId}</FormErrorMessage>
                                                </FormControl>
                                            </Box>
                                        </Box>
                                        <Box>
                                            <Image src={formValue.posterUrl} rounded={4} />
                                        </Box>

                                    </SimpleGrid>

                                    <Box px={0} py={4}>
                                        <FormControl>
                                            <FormLabel htmlFor='price'>Overview</FormLabel>
                                            <ReactQuill
                                                theme="snow"
                                                value={overview}
                                                onChange={setOverview}
                                                placeholder="Penjelasan Program"
                                                modules={modules}
                                                formats={formats}
                                            />
                                        </FormControl>
                                    </Box>

                                    <Box px={0} py={4}>
                                        <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                            <FormControl isRequired isInvalid={!!(errors.price && touched.price)}>
                                                <FormLabel htmlFor='price'>Harga</FormLabel>
                                                <Field
                                                    as={Input}
                                                    type={'number'}
                                                    min={0}
                                                    id='price'
                                                    name={'price'}
                                                    placeholder='Harga'
                                                    validate={(value: any) => {
                                                        let error;
                                                        if (value.length <= 0 || value < 0) {
                                                            error = "Harga wajib diisi."
                                                        }
                                                        return error;
                                                    }} />
                                                <FormErrorMessage>{errors.price}</FormErrorMessage>
                                            </FormControl>
                                            <FormControl isRequired isInvalid={!!(errors.priceOriginal && touched.priceOriginal)}>
                                                <FormLabel htmlFor='priceOriginal'>Harga Coret</FormLabel>
                                                <Field
                                                    as={Input}
                                                    type={'number'}
                                                    min={0}
                                                    id='priceOriginal'
                                                    name={'priceOriginal'}
                                                    placeholder='Harga Coret'
                                                    validate={(value: any) => {
                                                        let error;
                                                        if (value.length <= 0 || value < 0) {
                                                            error = "Harga Coret wajib diisi."
                                                        }
                                                        return error;
                                                    }} />
                                                <FormErrorMessage>{errors.priceOriginal}</FormErrorMessage>
                                            </FormControl>
                                        </SimpleGrid>
                                    </Box>

                                    <Box px={0} py={4}>
                                        <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                            <FormControl isRequired isInvalid={!!(errors.commissionFee && touched.commissionFee)}>
                                                <FormLabel htmlFor='commissionFee'>Komisi %</FormLabel>
                                                <Field
                                                    as={Input}
                                                    type={'number'}
                                                    min={0}
                                                    id='commissionFee'
                                                    name={'commissionFee'}
                                                    placeholder='Komisi'
                                                    validate={(value: any) => {
                                                        let error;
                                                        if (value.length <= 0 || value < 0) {
                                                            error = "Komisi wajib diisi."
                                                        }
                                                        return error;
                                                    }} />
                                                <FormErrorMessage>{errors.commissionFee}</FormErrorMessage>
                                            </FormControl>
                                        </SimpleGrid>
                                    </Box>

                                    <Box px={0} py={4}>
                                        <FormControl>
                                            <Checkbox
                                                id="isFeaturedInHomePage"
                                                name="isFeaturedInHomePage"
                                                onChange={(event: any) => {
                                                    setFieldValue("isFeaturedInHomePage", !values.isFeaturedInHomePage);
                                                }}
                                                isChecked={values.isFeaturedInHomePage}
                                            >
                                                Tampilkan di Homepage?
                                            </Checkbox>
                                        </FormControl>
                                    </Box>

                                    <Divider my={4} />

                                    <Box px={0} py={4}>
                                        <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                            <FormControl isRequired isInvalid={!!(errors.umaiPipelineId && touched.umaiPipelineId)}>
                                                <FormLabel htmlFor='piplelineId'>UMAI Pipeline</FormLabel>
                                                <Field
                                                    as={Select}
                                                    id='pipeline'
                                                    name={'umaiPipelineId'}
                                                    placeholder='Pilih UMAI Pipeline'
                                                    validate={(value: any) => {
                                                        let error;
                                                        if (!value)
                                                            error = "Silahkan pilih Pipeline Program ini";
                                                        return error;
                                                    }}
                                                >
                                                    {
                                                        salesPipelines.map((pipeline: any) => {
                                                            return <option value={pipeline.id}>{`${pipeline.name}`}</option>
                                                        })
                                                    }
                                                </Field>
                                                <FormErrorMessage>{errors.umaiPipelineId}</FormErrorMessage>
                                            </FormControl>
                                            <FormControl isRequired isInvalid={!!(errors.umaiPrefixTag && touched.umaiPrefixTag)}>
                                                <FormLabel htmlFor='kartraPrefixTag'>UMAI Prefix Tag</FormLabel>
                                                <Field
                                                    as={Input}
                                                    id='umaiPrefixTag'
                                                    name={'umaiPrefixTag'}
                                                    placeholder='Kartra Prefix Tag'
                                                    validate={(value: any) => {
                                                        let error;
                                                        if (value.length <= 0) {
                                                            error = "UMAI Prefix Tag wajib diisi."
                                                        }
                                                        return error;
                                                    }} />
                                                <FormErrorMessage>{errors.umaiPrefixTag}</FormErrorMessage>
                                            </FormControl>
                                        </SimpleGrid>
                                    </Box>

                                    <Box px={0} py={8}>
                                        <ButtonGroup gap={2}>
                                            <Button type={'submit'} isLoading={isSaving}>Simpan</Button>
                                            <Button variant={'outline'} onClick={() => { navigate(`/programs/${programId}`) }}>Kembali</Button>
                                        </ButtonGroup>
                                    </Box>
                                </form>
                            )
                        }
                    </Formik>
                </Box>
            </Container>
        </Layout>
    );
};

export default ProgramEditScene;